import { useNuxtApp } from "#app";
const directive = (el, { value }) => {
  const { $clientPosthog } = useNuxtApp();
  el.addEventListener("click", () => {
    if (!$clientPosthog) return;
    if (typeof value === "string") $clientPosthog.capture(value);
    else $clientPosthog.capture(value.name, value.properties);
  });
};
export const vPostHogCapture = {
  mounted: directive,
  updated: directive
};
